import { useTranslation } from 'react-i18next';

import { SidePanelSectionTabSt } from '~organisms/SidePanelSectionTab';

interface RemoveAllSelectedProductsModalProps {
  description: string;
  isOpen: boolean;
  title: string;
  onClose: () => void;
  onConfirm: () => void;
}

const RemoveAllSelectedProductsModal = ({
  description,
  isOpen,
  title,
  onClose,
  onConfirm,
}: RemoveAllSelectedProductsModalProps) => {
  const { t } = useTranslation();

  return (
    <SidePanelSectionTabSt.RemoveOptionModal
      open={isOpen}
      onCancel={onClose}
      footer={
        <SidePanelSectionTabSt.RemoveOptionModaFooterContainer>
          <SidePanelSectionTabSt.RemoveOptionModalButton onClick={onClose}>
            {t('COMMON.CLOSE')}
          </SidePanelSectionTabSt.RemoveOptionModalButton>

          <SidePanelSectionTabSt.RemoveOptionModalButton onClick={onConfirm}>
            {t('COMMON.YES')}
          </SidePanelSectionTabSt.RemoveOptionModalButton>
        </SidePanelSectionTabSt.RemoveOptionModaFooterContainer>
      }
    >
      <SidePanelSectionTabSt.RemoveOptionModalTitle>
        {title}
      </SidePanelSectionTabSt.RemoveOptionModalTitle>
      <SidePanelSectionTabSt.RemoveOptionModalDescription>
        {description}
      </SidePanelSectionTabSt.RemoveOptionModalDescription>
    </SidePanelSectionTabSt.RemoveOptionModal>
  );
};

export default RemoveAllSelectedProductsModal;
